import { render } from "./TopLevelMenuItemListView.vue?vue&type=template&id=d8518f2a"
import script from "./TopLevelMenuItemListView.vue?vue&type=script&lang=js"
export * from "./TopLevelMenuItemListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__